/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from '../types/index';

function IllustStatusLoadFail({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 200 200"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fill="#B6BAC1"
        d="M131.262 41.75c10.786 0 19.529 8.744 19.529 19.53v60.22c0 10.786-8.743 19.53-19.529 19.53h-86.21c-10.786 0-19.53-8.744-19.53-19.53V61.28c0-10.786 8.744-19.53 19.53-19.53zm-86.21 2.5c-9.406 0-17.03 7.625-17.03 17.03v60.22c0 9.405 7.624 17.03 17.03 17.03h86.21c9.405 0 17.029-7.625 17.029-17.03V61.28c0-9.405-7.624-17.03-17.029-17.03zm.87 13.04a3.86 3.86 0 1 1-.002 7.72 3.86 3.86 0 0 1 .002-7.72m15.21 0a3.86 3.86 0 1 1-.002 7.72 3.86 3.86 0 0 1 .002-7.72"
      />
      <path
        fill="#FAE100"
        d="M138.801 158.76c19.711 0 35.69-15.979 35.69-35.69s-15.979-35.69-35.69-35.69-35.69 15.979-35.69 35.69 15.979 35.69 35.69 35.69"
      />
      <path
        fill="#F9FAFB"
        d="m145.781 117.31 9.69 1.61c1.12.19 2.14-.7 2.1-1.84l-.35-9.82c-.05-1.52-1.85-2.29-2.99-1.29l-2.4 2.11a20.6 20.6 0 0 0-13.34-4.89c-11.38 0-20.63 9.26-20.63 20.63s9.26 20.63 20.63 20.63c7.1 0 13.61-3.58 17.42-9.58.81-1.27.43-2.95-.84-3.75a2.71 2.71 0 0 0-3.75.84c-2.81 4.42-7.61 7.06-12.83 7.06-8.38 0-15.2-6.82-15.2-15.2s6.82-15.2 15.2-15.2c3.36 0 6.57 1.11 9.2 3.1l-2.8 2.46c-1.14 1-.6 2.88.9 3.13z"
      />
    </svg>
  );
}
export default IllustStatusLoadFail;
